import useQueryParams from "./useQueryParams";

export default useQueryParams;
